import React from 'react';
import PropTypes from 'prop-types';
import { Rules } from 'Validation';
import ValidatedTextInput from './ValidatedTextInput';

const passwordValidation = password => (
  Rules.minPasswordLength(password) || Rules.strongPassword(password)
);

const PasswordInput = props => (
  <ValidatedTextInput
    {...props}
    autoComplete="off"
    type="password"
    validate={passwordValidation}
  />
);

PasswordInput.defaultProps = {
  className: '',
  label: 'Password:',
  placeholder: '',
  validateOnBlur: true,
  validateOnChange: false,
  value: undefined,
};

PasswordInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  value: PropTypes.string,
};

export default PasswordInput;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/TextInputs/PasswordInput.jsx